import styled from "styled-components";
import { compassLightGreyBackground } from "../../../styles";

/**
 * Main content container for modal body.
 * Provides consistent spacing and layout.
 */
export const ModalContent = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }): number => gap ?? 16}px;
  width: 100%;
  padding: 0;
`;

/**
 * Wrapper that hides content while preserving its layout space.
 * Use instead of conditional rendering when you want stable modal height.
 */
export const PreserveSpace = styled.div<{ hidden?: boolean }>`
  visibility: ${({ hidden }): string => (hidden ? "hidden" : "visible")};
`;

/**
 * Wrapper that fades content in/out while preserving layout space.
 */
export const FadeWrapper = styled.div<{ visible?: boolean }>`
  opacity: ${({ visible = true }): number => (visible ? 1 : 0)};
  transition: opacity 0.15s ease;
`;

/**
 * Container with fixed height for consistent modal layouts.
 */
export const FixedHeightRow = styled.div<{ height: number; overflow?: string }>`
  height: ${({ height }): string => `${height}px`};
  min-height: ${({ height }): string => `${height}px`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: ${({ overflow }): string => overflow ?? "visible"};
`;

/**
 * Standardized image/animation container for modals.
 * @deprecated Use the `hero` prop on CompassModal instead.
 */
export const ModalImageContainer = styled.div<{
  height?: number;
  padding?: number;
}>`
  height: ${({ height }): string => `${height ?? 200}px`};
  width: 100%;
  background: ${compassLightGreyBackground};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ padding }): string => `${padding ?? 30}px`};
  overflow: hidden;
  flex-shrink: 0;

  img,
  svg {
    max-width: 100%;
    object-fit: contain;
  }

  > div {
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
  }
`;

/**
 * Legacy content container with centered alignment and padding.
 * @deprecated Use ModalContent instead.
 */
export const ModalContentContainer = styled.div<{ padding?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ padding }): string => padding ?? "18px 30px"};
`;

/**
 * Item grid for vertical list of items with consistent spacing.
 */
export const ModalItemGrid = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }): number => gap ?? 6}px;
  width: 100%;
`;
